import { render, staticRenderFns } from "./FooterFaq.vue?vue&type=template&id=4648a6db&scoped=true&"
import script from "./FooterFaq.vue?vue&type=script&lang=ts&"
export * from "./FooterFaq.vue?vue&type=script&lang=ts&"
import style0 from "./FooterFaq.vue?vue&type=style&index=0&id=4648a6db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648a6db",
  null
  
)

export default component.exports